import { render, staticRenderFns } from "./VaRadioButton.demo.vue?vue&type=template&id=690db744&"
import script from "./VaRadioButton.demo.vue?vue&type=script&lang=js&"
export * from "./VaRadioButton.demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports